// Turns an axios error into one readable message for an alert. The backend answers in two shapes:
//   1. the LIS envelope      { success: false, message, errors: ["..."] }
//   2. ASP.NET model binding { title, status: 400, errors: { "$.effectiveTo": ["The JSON value could not be converted ..."] } }
// The second shape is technical, so field names are shown as words and known binder messages are rewritten.

const FIELD_LABELS = {
  effectiveto: 'Effective to', effectivefrom: 'Effective from', qualification: 'Qualification', medicalregno: 'Medical registration number',
  regauthority: 'Registration authority', designation: 'Designation', centreid: 'Centre', employeeid: 'Linked employee',
  doctorname: 'Doctor name', departmentid: 'Department', status: 'Status',
};

const fieldLabel = (key) => {
  const last = String(key || '').replace(/^\$\.?/, '').split('.').pop().replace(/\[\d+\]/g, '');
  if (!last) return '';
  return FIELD_LABELS[last.toLowerCase()] || last.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
};

const friendly = (label, text) => {
  const t = String(text || '');
  if (/could not be converted to .*(DateTime|DateOnly)/i.test(t)) return `${label || 'A date'}: enter a valid date or leave it empty.`;
  if (/could not be converted to .*(Int|Decimal|Double)/i.test(t)) return `${label || 'A number'}: enter a valid number.`;
  if (/field is required/i.test(t)) return label ? `${label} is required.` : 'Required details are missing.';
  if (/not a valid value|invalid/i.test(t) && label) return `${label}: ${t}`;
  // Prefix the field name unless the message already names it (whole words only, so "A" does not match "Bad").
  const words = ` ${t.toLowerCase().replace(/[^a-z0-9]+/g, ' ')} `;
  const mentionsLabel = !!label && words.includes(` ${label.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()} `);
  return label && !mentionsLabel ? `${label}: ${t}` : t;
};

export const describeValidationError = (err, fallback = 'The request failed.') => {
  const data = err?.response?.data;
  if (!data) return err?.message === 'Network Error' ? 'Cannot reach the server. Check that the backend is running.' : fallback;

  const lines = [];
  if (data.errors && !Array.isArray(data.errors) && typeof data.errors === 'object') {
    const keys = Object.keys(data.errors);
    const real = keys.filter((k) => !/^(dto|request|model|payload)$/i.test(k)); // "dto is required" is only a side effect of another error
    (real.length ? real : keys).forEach((k) => {
      const label = fieldLabel(k);
      [].concat(data.errors[k]).forEach((m) => lines.push(friendly(label, m)));
    });
  } else if (Array.isArray(data.errors)) {
    data.errors.filter((e) => e && e !== data.message).forEach((e) => lines.push(String(e)));
  }
  const head = data.message || (lines.length ? '' : data.title) || '';
  const unique = [...new Set(lines)];
  const text = [head, ...unique].filter(Boolean).join(' ');
  return text || fallback;
};

export default describeValidationError;
